export default __webpack_public_path__ + "static/media/database.1310b7fd.svg";